import PropTypes from "prop-types"
import React from "react"

class AvailabilityDonut extends React.Component {
  constructor(props) {
    super(props)

    // Bind methods
    this.warningDashArray = this.warningDashArray.bind(this)
    this.dangerDashArray = this.dangerDashArray.bind(this)
    this.dangerDashOffset = this.dangerDashOffset.bind(this)
    this.fullyAvailable = this.fullyAvailable.bind(this)
    this.renderCheckMark = this.renderCheckMark.bind(this)
  }

  warningDashArray() {
    const leftOverPercent = 100 - this.props.warningPercent
    return `${this.props.warningPercent} ${leftOverPercent}`
  }

  dangerDashArray() {
    const leftOverPercent = 100 - this.props.dangerPercent
    return `${this.props.dangerPercent} ${leftOverPercent}`
  }

  dangerDashOffset() {
    // Circumference − All preceding segments' total length + First segment's offset = Current segment offset
    return 100 - this.props.warningPercent
  }

  fullyAvailable() {
    return (
      parseInt(this.props.warningPercent) === 0 &&
      parseInt(this.props.dangerPercent) === 0
    )
  }

  renderCheckMark() {
    return (
      <div style={{ position: "absolute", left: "14px", lineHeight: "12px" }}>
        <svg width="12" height="9" viewBox="0 0 12 9" fill="none">
          <path
            d="M1.03906 4.29887L4.61244 7.36177L10.9935 0.725494"
            stroke="#7DC37C"
            strokeWidth="2"
          />
        </svg>
      </div>
    )
  }

  render() {
    return (
      <div className="relative flex items-center">
        <svg width="40px" height="40px" viewBox="0 0 42 42" className="donut">
          <circle
            className="donut-hole"
            cx="50%"
            cy="50%"
            r="15.91549430918954"
            fill="#fff"
          />
          <circle
            className="donut-segment"
            cx="50%"
            cy="50%"
            r="15.91549430918954"
            fill="transparent"
            style={{
              stroke: "#7DC37C",
              strokeWidth: 7,
            }}
          />

          {!this.fullyAvailable() && (
            <circle
              className="donut-segment"
              cx="50%"
              cy="50%"
              r="15.91549430918954"
              fill="transparent"
              style={{
                stroke: "#FFC107",
                strokeWidth: 7,
                strokeDasharray: this.warningDashArray(),
                strokeDashoffset: 0,
              }}
            />
          )}
          {!this.fullyAvailable() && (
            <circle
              className="donut-segment"
              cx="50%"
              cy="50%"
              r="15.91549430918954"
              fill="transparent"
              style={{
                stroke: "#C44346",
                strokeWidth: 7,
                strokeDasharray: this.dangerDashArray(),
                strokeDashoffset: this.dangerDashOffset(),
              }}
            />
          )}
          {this.fullyAvailable() && this.renderCheckMark()}
        </svg>
      </div>
    )
  }
}

AvailabilityDonut.propTypes = {
  warningPercent: PropTypes.number.isRequired,
  dangerPercent: PropTypes.number.isRequired,
}

export default AvailabilityDonut
